import ComponentRuleBuilder from '../components/custom/rule/ComponentRuleBuilder';
import ComponentField from '../components/custom/rule/ComponentField';

class ComponentRuleFactory {
  public static getChannel(): Record<string, ComponentField> {
    return {
      name: new ComponentField(ComponentRuleBuilder.rule().required().minLength(10).build()),
      description: new ComponentField(ComponentRuleBuilder.rule().build()),
      variables: new ComponentField(ComponentRuleBuilder.rule().minLength(1).required().build()),
    };
  }

  public static getChannelVariableCreator(): Record<string, ComponentField> {
    return {
      name: new ComponentField(ComponentRuleBuilder.rule().required().build()),
      description: new ComponentField(ComponentRuleBuilder.rule().build()),
      dataType: new ComponentField(ComponentRuleBuilder.rule().required().build()),
    };
  }
}

export default ComponentRuleFactory;
